/** Pure helpers for the portal "document" surfaces, split out from the component
 * module so React Fast Refresh stays happy (a file that exports components should
 * export only components). */

/** Terracotta portal accent for primary customer CTAs (the app's default button is
 * near-black; the portal leads with the brand accent). */
export const PORTAL_ACCENT_BTN =
  'bg-portal-accent text-portal-accent-foreground hover:bg-portal-accent/90';

/** Whole calendar days from today to a date-only / ISO value. Negative once
 * past. Tolerant of both 'YYYY-MM-DD' and full ISO strings. "Today" is the
 * VIEWER'S LOCAL calendar day (US/CA are all negative-UTC, so a UTC "today"
 * flips a day early each evening — making an invoice due today read "1 day
 * ago"); the target's date-only parts are compared against it. */
export function daysUntil(value: string): number {
  const [y, m, d] = value.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return NaN;
  const now = new Date();
  const target = Date.UTC(y, m - 1, d);
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86_400_000);
}

/** Up-to-two-letter initials for a brand mark ("Summit Air" → "SA"). */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
}
